import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer footer-slim">
      <div className="footer-content">
        <div className="footer-logo">
          <div className="footer-logo-container">
            <img src="/favicon.svg" alt="Kodly Logo" className="kodly-logo" />
            <a href="mailto:info@kodly.io" className="footer-email">info@kodly.io</a>
          </div>
        </div>
        
        <div className="footer-addresses">
          <div className="address-column">
            <h3 className="address-title">United Kingdom</h3>
            <div className="address-details">
              <p>840 Ibis Court, Centre Park</p>
              <p>Warrington</p>
              <p>Cheshire</p>
              <p>WA1 1RL</p>
            </div>
          </div>
          
          <div className="address-column">
            <h3 className="address-title">Portugal</h3>
            <div className="address-details">
              <p>Rua 5 de Outubro, 245</p>
              <p>4100-175, Porto</p>
              <p>Portugal</p>
            </div>
          </div>
          
          <div className="address-column">
            <h3 className="address-title">Spain</h3>
            <div className="address-details">
              <p>Gran Via de Carles III, 84</p>
              <p>08028, Barcelona</p>
              <p>España</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom-bar"></div>
    </footer>
  );
}

export default Footer;
